import React from 'react';
import { HiOutlineExclamation, HiOutlineTrash } from 'react-icons/hi';

function ConfirmModal({ 
  isOpen, 
  title, 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = 'Confirmar', 
  cancelText = 'Cancelar',
  type = 'danger' // 'danger' | 'warning' | 'info'
}) {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return <HiOutlineTrash size={48} style={{ color: 'var(--error)' }} />;
      case 'warning':
        return <HiOutlineExclamation size={48} style={{ color: 'var(--warning)' }} />;
      default:
        return <HiOutlineExclamation size={48} style={{ color: 'var(--primary)' }} />;
    }
  };

  const getConfirmButtonStyle = () => {
    switch (type) {
      case 'danger':
        return { background: 'linear-gradient(135deg, #ef4444, #dc2626)' };
      case 'warning':
        return { background: 'linear-gradient(135deg, #f59e0b, #d97706)' };
      default:
        return { background: 'var(--primary)' };
    }
  };

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal__icon">
          {getIcon()}
        </div>
        <h3 className="confirm-modal__title">{title}</h3>
        <p className="confirm-modal__message">{message}</p>
        <div className="confirm-modal__buttons">
          <button
            type="button"
            className="confirm-modal__btn confirm-modal__btn--cancel"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            type="button"
            className="confirm-modal__btn confirm-modal__btn--confirm"
            style={getConfirmButtonStyle()}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
